import { useLocalePath } from "@commercekit/remix";
import { asText } from "@prismicio/helpers";
import WvLink from "~/components/atoms/WvLink";
import type { ContentBlockSliceDuoContent } from "~/lib/prismic/types.generated";
import type { HTMLComponent } from "~/types/HTMLComponent";
import { optimizeImageUrl } from "~/lib/imageUtils";

const DuoContent: HTMLComponent<{
  slice: ContentBlockSliceDuoContent;
}> = ({ slice }) => {
  const localePath = useLocalePath();
  return (
    <div className="mb-3 component-duocontent mb-lg-5">
      <div className="container px-0">
        <div className="mx-0 row no-gutters">
          {slice.items &&
            slice.items.map((item, index) => (
              <WvLink
                key={index}
                to={localePath(`/${asText(item.ctaLink)}`)}
                className="col-12 col-lg-6 flex-1"
              >
                <div className="component-visualblock h-100">
                  <picture className="component-visualblock__image img--absolute">
                    <source
                      media="(max-width: 991px)"
                      srcSet={optimizeImageUrl(item.image.url || "")}
                    />
                    <source
                      media="(min-width: 992px)"
                      srcSet={optimizeImageUrl(item.image.url || "")}
                    />
                    <img
                      src={optimizeImageUrl(item.image.url || "")}
                      alt={item.image.alt || ""}
                      loading="lazy"
                    />
                  </picture>
                  <div className="px-3 component-visualblock__overlay h-100 w-100">
                    <div className="p-5 text-center d-flex flex-column justify-content-center align-items-center h-100">
                      <h2 className="mb-2 heading inverted fat xxl sans-serif">
                        {asText(item.title)} <span></span>
                      </h2>
                      <h3 className="mb-3 heading inverted">
                        {asText(item.description)}
                      </h3>
                      <button
                        type="button"
                        className="btn sentence-case"
                        data-icon-after=""
                      >
                        {asText(item.ctaText)}
                      </button>
                    </div>
                  </div>
                </div>
              </WvLink>
            ))}
        </div>
      </div>
    </div>
  );
};

export default DuoContent;
